
/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

const SharingBlock = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname, slider,
}) => {
  const initialState = {
    type: 'SharingBlock',
    title: false,
    size: false,
  };
  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);

  const [title, setTitle] = useState(false);
  const [size, setSize] = useState(false);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {

        const {
          title: currentTitle,
          size: currentSize,
        } = component;

        setState(component);
        setTitle(currentTitle);
        setSize(currentSize);

      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const construction = {
      type: state.type,
      compId: state.compId || '',
      title: { ...title },
      size,
    }
    handlerSetComponents({ component: construction }, componentIndex);
  }, [
    title,
    size,
  ]);

  const titleChange = (e) => {
    if(title){
      title[activeLanguage] = e.target.value
      console.log("titleChange -> title", title)
      setTitle({ ...title });
    } else {
      setTitle({});
    }
  }

  return (
    <div className="flex justify-start flex-col text-black">
      {/* Single Form */}
      <div className="flex">
        <div className="flex-2 mr-4">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          >
            Title
          </label>
          <input
            className="appearance-none block
            bg-gray-200 text-gray-700 border border-red-500
            rounded py-3 px-4 w-full leading-tight focus:outline-none
            focus:bg-white"
            type="text"
            onChange={titleChange}
            value={title && title[activeLanguage] ? title[activeLanguage] : ''}
          />
        </div>
        <div className=" xl:mr-4 lg:w-1/4 xl:w-1/4 w-full">
          <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
            Text Size
                  </label>
          <div className="relative">
            <select
              className="block appearance-none w-full
                bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8
                rounded leading-tight focus:outline-none focus:bg-white
                focus:border-gray-500"
              value={size}
              onChange={e => setSize(e.target.value === "false" ? false : e.target.value)}
            >
              <option value={false}>Default</option>
              <option value={'small'}>small</option>
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0
              flex items-center px-2 text-gray-700 h-12 top-0">
              <svg
                className="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                /></svg>
            </div>
          </div>
        </div>
      </div>
      {/* End */}

    </div>
  );
};

SharingBlock.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  slider: PropTypes.bool,
};
SharingBlock.defaultProps = {
  reusableComponent: null,
  slider: false,
};

export default SharingBlock;
